<!--天澄建筑区域划分-->
<template>
    <div class="unitManageBody">
        <!--头部按钮部分-->
        <div class="unitMangeTitle">
            <iconButton v-show="isArea" @buttonClick='addGroup' buttonText='添加组' icoName="wedoButton/add.png"></iconButton>
			<iconButton v-show="isArea && !isContainer" @buttonClick='addDevice' buttonText='添加设备' icoName="wedoButton/add.png"></iconButton>
			<iconButton v-show="isArea && !isContainer" @buttonClick='editGroup' buttonText='修改' icoName="wedoButton/edit.png"></iconButton>
			<iconButton v-show="!isContainer" @buttonClick='deleteOperate' buttonText='删除' icoName="wedoButton/delete.png"></iconButton>
			<iconButton @buttonClick='refresh' buttonText='刷新' icoName="wedoButton/delete.png"></iconButton>
        </div>
        <div class="buildingAreaContainer">
			<div class="buildingAreaLeft">
				<div class="buildingAreaTitle">
					<span>通信设备列表</span>
				</div>
				<div class="buildingAreaBox custom-scrollbar" style="background-color: lightblue;">
					<virtualDeviceTree slot="tree" ref="channelAndDeviceTree" :dataList="channelAndDeviceTree" :autoSelectMethod='autoSelectMethod'
					 :isGroup="isGroup" :groupCheckAble="false" @checkItem="checkItem"></virtualDeviceTree>
				</div>
				<div class="buildingAreaBox custom-scrollbar">
					<table>
						<tr>
							<th>变量名称</th>
							<th>通道号</th>
							<th>设备号</th>
						</tr>
						<tr v-for="item in nowDeviceVariableList">
							<td>{{ item.name }}</td>
							<td>{{ item.channelNo }}</td>
							<td>{{ item.deviceNo }}</td>
						</tr>
					</table>
				</div>
			</div>
			<div class="buildingAreaRight">
				<div class="buildingAreaTitle">
					<span>虚拟设备列表</span>
				</div>
				<div class="buildingAreaBox custom-scrollbar" style="background-color: lightblue;">
					<virtualDeviceTree slot="tree" ref="channelAndVirtualDeviceTree" :dataList="channelAndVirtualDeviceTree" :isGroup="isGroup" :groupCheckAble="true" @checkItem="checkItemTwo"></virtualDeviceTree>
				</div>
				<div class="buildingAreaBox custom-scrollbar">
					<table>
						<tr>
							<th>变量名称</th>
							<th>通道号</th>
							<th>设备号</th>
						</tr>
						<tr v-for="item in nowDeviceVariableListTwo">
							<td>{{ item.name }}</td>
							<td>{{ item.fromConnect }}</td>
							<td>{{ item.fromObject }}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
		<AddNewGroupDialog ref="addNewGroupDialog"></AddNewGroupDialog>
    </div>
</template>

<script>	
import virtualDeviceTree from '@/components/module/tree/virtualDeviceTree.vue'
import iconButton from '@/components/module/universal/iconButton.vue'
import AddNewGroupDialog from './AddNewGroupDialog.vue'

export default {
    components: {
		virtualDeviceTree,
        iconButton,
		AddNewGroupDialog,
    },
    props: {},
    data() {
        return {
			channelAndDeviceTree: [],
			channelAndVirtualDeviceTree: [],
			nowDeviceVariableList: [],
			nowDeviceVariableListTwo: [],
			isContainer: false,
			isArea: false,
			nowCheckedItem: undefined,
			newSort: 0,
        }
    },
    created() {},
    mounted() {
		this.getChannelAndDeviceTree()
		this.getChannelAndVirtualDeviceTree()
	},
    destroyed() {},
    computed: {
		addedDeviceNos() {
			if(isempty(this.channelAndVirtualDeviceTree)) {
				return []
			}
			var nos = []
			this.getAddedDeviceNos(this.channelAndVirtualDeviceTree, nos)
			return nos.sort()
		}
    },
    watch: {
		
    },
    methods: {
        //添加组
		addGroup() {
			if(this.nowCheckedItem == undefined) {
				this.$dialogMethod.showMessage("请选择要添加组的区域！")
				return
			}
			this.$refs.addNewGroupDialog.open('添加组', (name) => {
				this.$api.deviceApi.saveAppClassType(undefined, name, this.nowCheckedItem.no, undefined, this.newSort, '0', respon => {
					this.$dialogMethod.showMessage('添加组：' + respon.name + ' 成功！')
					this.getChannelAndVirtualDeviceTree()
				}, err => {
					this.$dialogMethod.showMessage(err)
				})
			})
		},
		// 添加设备
		addDevice() {
			this.$api.deviceApi.saveVirtualDevice(undefined, this.nowCheckedVariable.name, this.nowCheckedItem.no, this.nowCheckedVariable.no, this.nowCheckedVariable.parentarea, respon => {
				this.$dialogMethod.showMessage('添加成功！')
				this.getChannelAndVirtualDeviceTree()
			}, err => {
				this.$dialogMethod.showMessage(err)
			})
		},
		//修改
		editGroup() {
			this.$refs.addNewGroupDialog.open('修改组', (name) => {
				this.$api.deviceApi.saveAppClassType(this.nowCheckedItem.no, name, this.nowCheckedItem.fatherno, this.nowCheckedItem.unitid, this.nowCheckedItem.sort, this.nowCheckedItem.devicetype, respon => {
					this.$dialogMethod.showMessage('修改组成功！')
					this.getChannelAndVirtualDeviceTree()
				}, err => {
					this.$dialogMethod.showMessage(err)
				})
			})
		},
		// 删除
		deleteOperate() {
			if(this.nowCheckedItem == undefined) {
				this.$dialogMethod.showMessage("请先选中要删除的部分!")
				return
			}
			if(!isempty(this.nowCheckedItem.unitid) && this.nowCheckedItem.unitid != undefined) {
				this.$dialogMethod.showMessage("当前组不可删除!")
				return
			}
			if(this.nowCheckedItem.entityName != undefined && this.nowCheckedItem.entityName == 'VirtualDevicePojo') {
				this.$api.deviceApi.deleteVirtualDevice(this.nowCheckedItem.no, respon => {
					this.$dialogMethod.showMessage('删除设备：'+ this.nowCheckedItem.name +' 成功！')
					this.getChannelAndVirtualDeviceTree()
				}, err => {
					this.$dialogMethod.showMessage(err)
				})
			}else{
				this.$api.deviceApi.deleteAppClassType(this.nowCheckedItem.no, respon => {
					this.$dialogMethod.showMessage('删除组：'+ this.nowCheckedItem.name +' 成功！')
					this.getChannelAndVirtualDeviceTree()
				}, err => {
					this.$dialogMethod.showMessage(err)
				})
			}
		},
		// 刷新
		refresh() {
			this.getChannelAndDeviceTree()
			this.getChannelAndVirtualDeviceTree()
		},
		autoSelectMethod(item, index) {
			return item.entityName == 'Device'
		},
		isGroup(item) {
			return item.hasOwnProperty('next')
		},
		checkItem(item) {
			this.nowCheckedVariable = item
			this.nowDeviceVariableList = []
			this.getGenerallyVariableByDeviceNoLimit(item)
		},
		checkItemTwo(item) {
			this.nowDeviceVariableListTwo = []
			this.nowCheckedItem = item
			this.isContainer = item.no == 0 ? true : false
			if(isempty(item.next) || item.next == undefined) {
				this.newSort = 1
			}else{
				var sort = 0
				for(let i = 0;i < item.next.length;i++) {
					if(item.next[i].sort > sort) {
						sort = item.next[i].sort
					}
				}
				this.newSort = sort + 1
			}
			if(item.entityName == 'VirtualDevicePojo') {
				this.isArea = false
				this.getVariableList(item)
			}else{
				this.isArea = true
			}
		},
		getChannelAndDeviceTree() {
			this.$api.deviceApi.getChannelAndDeviceTree(respon => {
				this.channelAndDeviceTree = [respon]
			}, err => {
				this.$dialogMethod.showMessage(err)
			})
		},
		getChannelAndVirtualDeviceTree() {
			this.$api.deviceApi.getChannelAndVirtualDeviceTree(respon => {
				this.channelAndVirtualDeviceTree = [respon]
			}, err => {
				this.$dialogMethod.showMessage(err)
			})
		},
		getGenerallyVariableByDeviceNoLimit(item) {
			this.$api.channelApi.getGenerallyVariableByDeviceNoLimit(item.id, 1, 1000, respon => {
				this.nowDeviceVariableList = respon.data
			}, err => {
				this.$dialogMethod.showMessage(err)
			})
		},
		getVariableList(item) {
			this.$api.variableApi.getVariableList(item.no, respon => {
				this.nowDeviceVariableListTwo = respon
			}, err => {
				this.$dialogMethod.showMessage(err)
			})
		},
		getAddedDeviceNos(list, arr) {
			for(let i = 0;i < list.length;i++) {
				if(list[i].entityName != undefined && list[i].entityName == 'VirtualDevicePojo') {
					arr.push(list[i].no)
				}else if(!isempty(list[i].next)) {
					this.getAddedDeviceNos(list[i].next, arr)
				}
			}
		}
    }
}
</script>

<style scoped>
.unitManageBody {
    width: 100%;
    height: 100%;
}

.unitMangeTitle {
    width: 95%;
    margin: 0 auto;
    height: 5%;
    margin-top: 0.1rem;
    display: flex;
    align-items: center;
}

.buildingAreaContainer {
	background-color: white;
	display: flex;
	justify-content: space-between;
	height: calc(100% - 75px);
	margin: 10px;
}

.buildingAreaLeft,.buildingAreaRight {
	width: calc(50% - 5px);
	height: calc(100% - 30px);
}

.buildingAreaTitle {
	padding-left: 10px;
}

.buildingAreaTitle>span {
	line-height: 30px;
	font-size: 14px;
	font-weight: 600;
}

.buildingAreaBox {
	border: solid 1px #828790;
	box-sizing: border-box;
	height: calc(50% - 5px);
	padding: 10px;
}

.buildingAreaBox:last-child {
	margin-top: 10px;
}

table{
	min-width: 100%;
	width: auto;
	overflow: hidden;
	table-layout: fixed;
	background-color: #FFFFFF;
}

tr:hover{
	background-color: #F2F2F2;
}

th,td{
	border-bottom: solid 1px #DCDFE6;
	padding: 4px 0;
}

td{
	text-align: center;
	min-width: 120px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow:ellipsis;
}
</style>
